module.exports = __webpack_public_path__ + "static/media/RQ5.03aed4f3.pdf";